/**
 * Reload the window to force a restart of the app.
 * We count the number of reloads to prevent an infinite loop
 *
 * @param {string} [stateKey='reloadCount'] Key to hold reload count
 * @param {number} [maxRetries=2] Max number of times to reload
 * @returns {boolean} True if a reload has triggered, false is maxRetries were exceeded
 */
const reloadWithCounter = (stateKey = 'reloadCount', maxRetries = 2) => {
  const counter = window.history?.state?.[stateKey] ?? 0;

  if (counter < maxRetries) {
    window.history.pushState({ ...window.history.state, [stateKey]: counter + 1 }, '');
    window.location.reload();
    return true;
  }

  return false;
};

export default reloadWithCounter;
